import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Flex, Text, Input } from '@chakra-ui/react';
import { useSemanticTypography } from '@whitbread-eos/utils';
import { Path, Rectangle } from '../../assets/icons';
import { formatDataTestId } from '../../utils/formatters';
import Button from '../Button';
import Icon from '../Icon';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function AddSubtract(_ref) {
  var onSubtract = _ref.onSubtract,
    onPlus = _ref.onPlus,
    value = _ref.value,
    label = _ref.label,
    isSubtractDisable = _ref.isSubtractDisable,
    prefixDataTestId = _ref.prefixDataTestId,
    isPlusDisable = _ref.isPlusDisable,
    _ref$isPlusHidden = _ref.isPlusHidden,
    isPlusHidden = _ref$isPlusHidden === void 0 ? false : _ref$isPlusHidden,
    _ref$isSubtractHidden = _ref.isSubtractHidden,
    isSubtractHidden = _ref$isSubtractHidden === void 0 ? false : _ref$isSubtractHidden,
    _ref$isEditable = _ref.isEditable,
    isEditable = _ref$isEditable === void 0 ? false : _ref$isEditable,
    handleInputChange = _ref.handleInputChange,
    maxLength = _ref.maxLength;
  var getTypographyProps = useSemanticTypography();
  return _jsxs(Flex, _objectSpread(_objectSpread({}, wrapperContainer), {}, {
    children: [_jsxs(Flex, _objectSpread(_objectSpread({}, wrapperController), {}, {
      children: [!isSubtractHidden && _jsx(Button, {
        size: "xs",
        variant: "circle",
        onClick: onSubtract,
        isDisabled: isSubtractDisable,
        "aria-label": "Decrease quantity",
        "data-testid": formatDataTestId(prefixDataTestId, 'SubtractButton'),
        sx: onActiveIconStyle(isSubtractDisable),
        children: _jsx(Icon, {
          svg: _jsx(Rectangle, {
            color: choseIconColor(isSubtractDisable)
          })
        })
      }), isEditable ? _jsx(Input, {
        value: isNaN(value) ? 0 : value,
        onChange: e => {
          var _e$target;
          handleInputChange === null || handleInputChange === void 0 || handleInputChange(parseInt(e === null || e === void 0 || (_e$target = e.target) === null || _e$target === void 0 ? void 0 : _e$target.value));
        },
        maxLength: maxLength,
        "data-testid": formatDataTestId(prefixDataTestId, 'inputValue')
      }) : _jsx(Text, _objectSpread(_objectSpread(_objectSpread({}, valueStyle), getTypographyProps(valueLegacyTypography, valueSemanticTypography)), {}, {
        "data-testid": formatDataTestId(prefixDataTestId, 'Value'),
        children: value
      })), !isPlusHidden && _jsx(Button, {
        size: "xs",
        variant: "circle",
        onClick: onPlus,
        isDisabled: isPlusDisable,
        "aria-label": "Increase quantity",
        "data-testid": formatDataTestId(prefixDataTestId, 'AddButton'),
        sx: onActiveIconStyle(isPlusDisable),
        children: _jsx(Icon, {
          svg: _jsx(Path, {
            color: choseIconColor(isPlusDisable)
          })
        })
      })]
    })), _jsx(Text, _objectSpread(_objectSpread(_objectSpread({}, labelStyle), getTypographyProps(labelLegacyTypography, labelSemanticTypography)), {}, {
      "data-testid": formatDataTestId(prefixDataTestId, 'Label'),
      children: label
    }))]
  }));
}
var onActiveIconStyle = isDisabled => isDisabled ? '' : {
  '&:active > div > svg': {
    path: {
      fill: 'white'
    }
  }
};
var choseIconColor = isDisable => isDisable ? 'var(--chakra-colors-darkGrey2)' : 'var(--chakra-colors-primary)';
var valueStyle = {
  width: 'var(--chakra-space-3xl)',
  px: '1.063rem',
  color: 'darkGrey1',
  align: 'center'
};
var valueLegacyTypography = {
  fontSize: '2xl',
  fontWeight: 'medium',
  lineHeight: '4'
};
var valueSemanticTypography = {
  textStyle: 'heading-m'
};
var labelStyle = {
  color: 'darkGrey1'
};
var labelLegacyTypography = {
  fontSize: 'md',
  fontWeight: 'medium',
  lineHeight: '3'
};
var labelSemanticTypography = {
  textStyle: 'body-m-regular'
};
var wrapperContainer = {
  flexDir: 'column',
  alignItems: 'center',
  justifyContent: 'center'
};
var wrapperController = {
  alignItems: 'center',
  justifyContent: 'center'
};